define('post-editor/margin-plugin',['post-editor/sidebar-api', 'post-editor/mce-tools', 'post-editor/NumericInputWidget'],
		function(api, mceTools, _) {
	var idPrefix = 'postEditorSidebarMargin_';
	
	var element;
	
	function onInputChange(propertyName, value) {
		editor.undoManager.transact(function() {
			mceTools.setCss($(element), propertyName, value);
		});
	}
	
	function onInputPeek(propertyName, value) {
		editor.undoManager.beforeChange();
		mceTools.setCss($(element), propertyName, value);
	}
	
	api.defineGroups('p h1 h2 h3 h4 h5 h6 h7 h8 quote table img', [ {
		title: 'Abstände',
		collapsedByDefault: true,
		type: 'form',
		layout: 'grid',
		columns: 1,
		padding: 0,
		items: [{
			type: 'numeric',
			id: idPrefix + 'marginTop',
			label: 'Oben:',
			maxWidth: 150,
			property: 'margin-top'
		},{
			type: 'numeric',
			id: idPrefix + 'marginBottom',
			label: 'Unten:',
			maxWidth: 150,
			property: 'margin-bottom'
		},{
			type: 'numeric',
			id: idPrefix + 'marginLeft',
			label: 'Links:',
			maxWidth: 150,
			property: 'margin-left'
		},{
			type: 'numeric',
			id: idPrefix + 'marginRight',
			label: 'Rechts:',
			maxWidth: 150,
			property: 'margin-right'
		}],
		
		onRendered: function(editor) {
			function initNumeric(id, propertyName) {
				var control = $('#' + id).data('control');
				control.on('change', function(value) {
					onInputChange(propertyName, value);
				});
				control.on('peek', function(value) {
					onInputPeek(propertyName, value);
				});
			}
			
			this.items.forEach(function(item) {
				if (item.property) {
					initNumeric(item.id, item.property);
				}
			});
		},
		
		onOpen: function(ui, el, editor) {
			element = el;
			
			this.items.forEach(function(item) {
				if (item.property) {
					var control = $('#' + item.id).data('control');
					control.setValue(parseInt($(element).css(item.property)));
				}
			});
		}
	}]);
});

